import { merge } from "lodash";
import { fetcher } from "../utils/fetcher";

class LazyScript {
  constructor(element){  
    this.container = element; 
    this.src = element.dataset.src;
    this.isInitialised = false;

    this.init();
  }

  init(){
    const intersectionCallback = (entries, observer) => {
      entries.forEach(entry => {       
        if (entry.isIntersecting && !this.isInitialised) {
          this.insertScript();
        }
      });
    }
    
    const observer = new IntersectionObserver(intersectionCallback, {
      root: null,
      rootMargin: '0px 0px 500px 0px',
      threshold: 0
    });

    observer.observe(this.container);    
  }

  insertScript(){
    const script = document.createElement('script');
    script.src = this.src;
    this.container.after(script);
    this.isInitialised = true;
  }
}
const elements = document.querySelectorAll('.js-LazyScript');

elements.forEach(element => {
  new LazyScript(element)
})